import { render, staticRenderFns } from "./recommend_item_advertise1.vue?vue&type=template&id=8e8fc89a&scoped=true&"
import script from "./recommend_item_advertise1.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_advertise1.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_advertise1.vue?vue&type=style&index=0&id=8e8fc89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8fc89a",
  null
  
)

export default component.exports